<ion-header class="ion-header-login">
    <ion-toolbar>
        <div class="header-grid">
            <div class="main-logo-sec">
                <img src="assets/images/eZintegration-black-logo.svg">
            </div>
        </div>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="login-container">
      <div class="login-content-grid">
        <div class="grid-content">
          <div class="company-logo-sec">
            <a target="_blank" id="login_bizdata_logo" href="https://www.bizdata360.com/">
              <img src="assets/images/bizdata-header-logo.png">
            </a>
          </div>
          <div class="login-viewgrid">
            <div class="login-viewgrid-title">
              Vendor Login - Your Gateway to the API Marketplace
            </div>
            <mat-card>
              <mat-card-content>
                <div class="signin-sec">
                  Login
                </div>
                <div class="login-sec-title">
                  (Only eZintegration API Marketplace Vendor Login)
                </div>
                <div id="login_ezintegration_logo" class="main-logo-sec">
                  <img src="assets/images/eZintegration-black-logo.svg">
                </div>
                <div class="form-container">
                  <form [formGroup]="loginform" (ngSubmit)="onSubmitlogin()">
                    <mat-form-field appearance="outline">
                      <mat-label>Username</mat-label>
                      <input type="text" id="login_username" matInput placeholder="Username" formControlName="email" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Password</mat-label>
                      <input [type]="password ? 'password' : 'text'" id="login_password" matInput placeholder="Password"
                        formControlName="password" required>
                      <mat-icon matSuffix (click)="password = !password">{{password ? 'visibility_off' :
                        'visibility'}}</mat-icon>
                    </mat-form-field>
                    <mat-checkbox formControlName="remember" id="login_checkbox" class="checkbox-remember-me">Remember me</mat-checkbox>
                    <div class="btn-signin-grid">
                      <button mat-raised-button type="submit" id="login_submit" class="btn-signin">Login</button>
                    </div>
                  </form>
                  <p class="forgot-password" routerLink="/vendor/forgot-password" id="login_forgot_password"><a href="javascript:void(0)"
                      style="text-decoration: none; font-weight: 500;">Forgot Password?</a></p>
                  <p id="loginTryHere">Don't have an account! <a class="signin-link" style="text-decoration: none; font-weight: 500;"
                      routerLink="/vendor/sign-up" href="javascript:void(0)">Try it here </a></p>
                </div>
  
              </mat-card-content>
            </mat-card>
          </div>
          <app-powered-by-footer></app-powered-by-footer>
        </div>
      </div>
      <div class="login-bg-grid">
        <div class="bg-content-grid">
          <div class="views-content">
            <span class="content-1"> REIMAGINE DATA</span>
            <p class="content-2"> Transforming Companies With Data Integration Platform : eZintegrations </p>
            <h5 class="content-3"> Find out what's new! </h5>
          </div>
          <div class="views-btn">
            <button mat-raised-button class="btn-learn-more" id="login_learn_more"><a mat-button class="btn-learn-more"
                href="https://www.bizdata360.com/" target="_blank">Learn More</a></button>
          </div>
          <mat-divider></mat-divider>
          <div class="views-btn-socialIcons">
            <a id="login_facebook" href="https://www.facebook.com/bizdata360/" target="_blank"> <img src="assets/images/facebook.svg"> </a>
            <a id="login_linkedin" href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQH3FGvJ67canAAAAX9eldyQIpjcYnTE01nLHIN658448wJWgxlftcAkuusyGSiiS-jbInHncmK_8qMHXshF87igV-yfS4dPhopLU86otDiYAbtGaAt3-BDCnJQl0xRoaCo9_VI=&originalReferer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fbizdata-inc%2F"
              target="_blank"> <img src="assets/images/linkedin.svg"></a>
            <a id="login_twitter" href="https://twitter.com/bizdata360" target="_blank"> <img src="assets/images/new_twitter.svg"></a>
            <a id="login_pinterst" href="https://www.pinterest.com/Bizdata/" target="_blank"> <img src="assets/images/pinterest.svg"></a>
            <a id="login_youtube" href="https://www.youtube.com/c/BizdataInc/videos" target="_blank"> <img
                src="assets/images/youtube.svg"></a>
          </div>
        </div>
      </div>
    </div>
  </ion-content>